{
  "links" : {
    "triggerLinksDescription" : "Liens de SMS suppression de Gmail l' pour mettre des liens à l'intérieur messages .",
    "enterName" : "Saisis le nom",
    "enterLinkURL" : "Entrez l'URL du lien",
    "save" : "Archives",
    "cancel" : "Annuler",
    "delete" : "Supprimer",
    "aboutToDeleteLink" : "' Vous êtes sur le point de supprimer le ${deleteRowName} ? ) Le lien pris en charge ne peut pas être restauré, voulez-vous vraiment continuer?",
    "noTriggerLinksFound" : "Aucun lien trouvé",
    "getStartedByAddingNewTriggerLinks" : "Commencer par ajouter de nouveaux liens de location",
    "newTriggerLink" : "Nouveau lien",
    "searchNoMatch" : "Votre recherche ne correspondait à aucun lien direct.",
    "link" : "Lien",
    "addLink" : "Ajouter un Lien",
    "linkURL" : "Lien Url",
    "name" : "Nom",
    "pleaseEnterNonEmptyLinkName" : "Veuillez saisir un nom de lien non vide",
    "pleaseEnterURL" : "Veuillez saisir l'URL",
    "actions" : "activités",
    "linkKey" : "Clé de Lien",
    "keyCopied" : "Copier la clé"
  }
}
